// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormHelperText } from '@mui/material';
//
import Editor, { Props as EditorProps } from '../editor';

// ----------------------------------------------------------------------

interface Props extends EditorProps {
  name: string;
}

export default function RHFEditor({ name, ...other }: Props) {
  const { control } = useFormContext();

  const modifyId = (string: string) => {
    if (string) {
      const arr = string?.split('.');
      let finalString = arr[0];
      for(let i = 1; i < arr.length; i++) {
          finalString = finalString + arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      return finalString.replace('[', '').replace(']', '');
    }
  }

  const newId = modifyId(name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Editor
          id={newId}
          value={field.value}
          onChange={field.onChange}
          error={!!error}
          helperText={error?.message &&
            <FormHelperText error sx={{ px: 2, textTransform: 'capitalize' }}>
              {error?.message}
            </FormHelperText>
          }
          {...other}
        />
      )}
    />
  );
}
